import { tokens } from '@arvoreeducacao/bonsai-ds'
import { useEffect } from 'react'
import { useFeatureTogglesStore } from 'stores/featureTogglesStore'
import { activateHandTalk } from 'utils/hand-talk-widget'

export const openAccessibilityMenu = (vLibrasEnabled?: boolean) => {
  if (vLibrasEnabled) {
    activateHandTalk()
    return
  }

  if (window?.UserWay?.widgetOpen) {
    window?.UserWay?.widgetOpen()
  }
}

const AccessibilityWidget = () => {
  const { featureToggles } = useFeatureTogglesStore()

  useEffect(() => {
    if (featureToggles.vLibrasEnabled) return

    const script = document.createElement('script')
    script.setAttribute('data-account', 'UTiGXO6XRM')
    script.setAttribute('src', 'https://cdn.userway.org/widget.js')
    script.setAttribute('data-color', tokens.colors.livrosMedium)
    script.setAttribute('data-size', 'small')
    script.setAttribute('data-language', 'pt')
    document.body.appendChild(script)

    script.onload = () => {
      if (window?.UserWay) {
        const checkUserWay = () => {
          if (window.UserWay.preloadWidget) {
            window.UserWay.preloadWidget()
          } else {
            setTimeout(checkUserWay, 500)
          }
        }
        checkUserWay()
      }
    }

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script)
      }
    }
  }, [featureToggles.vLibrasEnabled])

  return null
}

export default AccessibilityWidget
